<template lang='pug'>
  div
    v-text-field(
      v-model='search'
      :label='label'
      append-icon='search'
      @input='onSearch'
    )
    v-list
      v-list-tile(v-for='item in itemsInternal' :key='item.value')
        v-list-tile-action
          v-checkbox(v-model='selecteds' :value='item.value')
        v-list-tile-content
          v-list-tile-title {{ item.text }}
</template>

<script>
import _ from 'lodash'

export default {
  name: 'select-multiple',

  props: {
    value: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },

  watch: {
    value(val) {
      this.onUpdateSelecteds(val)
    },
    items(val) {
      this.onUpdateItemsInternal(val)
    },
    selecteds(val) {
      this.$emit('input', val)
    }
  },

  mounted() {
    this.onUpdateSelecteds(this.value)
    this.onUpdateItemsInternal(this.items)
  },

  data() {
    return {
      search: '',
      selecteds: [],
      itemsInternal: []
    }
  },

  methods: {
    onClickListItem(item) {
      console.log(this.$refs[item.value])
      this.$refs[item.value][0].$el.click()
    },
    onUpdateSelecteds(payload) {
      console.log(this.selecteds, payload)
      if (this.selecteds === payload) return

      this.search = ''
      this.selecteds = _.cloneDeep(payload)
    },
    onUpdateItemsInternal(payload) {
      this.search = ''
      this.itemsInternal = _.cloneDeep(payload)
    },
    onSearch(payload) {
      this.itemsInternal = this.items.filter(item => item.text.toLowerCase().indexOf(payload) > -1)
    }
  }
}
</script>

<style lang='stylus' scoped>
</style>
